import React from "react";
import { Link } from "react-router-dom";

export const P = ({ children }) => (
  <p className="text-zinc-400 leading-relaxed mb-5">{children}</p>
);
export const H2 = ({ children }) => (
  <h2 className="text-2xl font-semibold text-zinc-100 mt-10 mb-4 tracking-tight">{children}</h2>
);
const Img = ({ src, alt, caption, narrow }) => (
  <figure className={`my-8 ${narrow ? "max-w-xs mx-auto" : ""}`}>
    <img src={src} alt={alt} loading="lazy" className="rounded-xl border border-zinc-800 w-full" />
    <figcaption className="text-xs text-zinc-600 mt-2 text-center">{caption}</figcaption>
  </figure>
);

const LaunchArticle = () => (
  <>
    <P>
      Po měsících vývoje a testování s reálnými tradery oficiálně spouštíme <strong className="text-zinc-200">TradeMind AI</strong> —
      českou webovou i mobilní aplikaci, která spojuje AI analýzu grafů, obchodní deník, risk management
      a ochranu prop firm účtu do jediné platformy. Aplikace je dostupná na webu trademind.cz a míří i do Google Play.
    </P>
    <H2>Proč TradeMind AI vznikl</H2>
    <P>
      Většina traderů neselhává kvůli špatné strategii, ale kvůli chybějící trading disciplíně: přeobchodování,
      posouvání stop lossu, obchodování bez plánu a porušování pravidel prop trading firem.
      Statistiky prop firem mluví jasně — přes 90 % challenge účtů končí neúspěchem, a to nejčastěji porušením
      denního limitu ztráty. Přesně tento problém TradeMind AI řeší: dává traderovi AI parťáka, který analyzuje,
      hlídá a vede k disciplíně 24 hodin denně.
    </P>
    <H2>Co aplikace umí</H2>
    <P>
      <strong className="text-zinc-200">AI analýza grafu ze screenshotu</strong> — vyfotíte graf, AI vrátí doporučení
      BUY / SELL / WAIT včetně vstupní ceny, stop lossu, take profitů a důvodů. Ke každé analýze dostanete
      AI scoring kvality setupu (A+ až F).
    </P>
    <P>
      <strong className="text-zinc-200">Obchodní deník</strong> — záznam obchodů ručně i importem screenshotu (OCR),
      statistiky winrate, RR a equity křivka, složky pro více účtů, export do PDF a CSV. Deník podporuje denní
      streaky a odznaky, které budují návyk pravidelného zapisování.
    </P>
    <P>
      <strong className="text-zinc-200">Prop Firm Guardian</strong> — pohlídá denní limit ztráty, maximální drawdown
      i profit target vašeho challenge nebo funded účtu. Varuje dřív, než pravidlo porušíte.
    </P>
    <P>
      <strong className="text-zinc-200">AI Trading Mentor</strong> — chat s mentorem, který zná vaše statistiky
      z deníku a čerpá živá tržní data. Market Scanner, ekonomický kalendář a chytré alerty doplňují celek.
    </P>
    <H2>Pro koho je TradeMind AI určen</H2>
    <P>
      Pro tradery na Forexu, kryptoměnách, zlatě i indexech — od začátečníků, kteří potřebují druhý názor na svůj
      setup, po prop firm tradery, kteří si nemohou dovolit porušit pravidla challenge. Ideální pro prop firm
      challenge i funded účty.
    </P>
    <H2>Kolik to stojí</H2>
    <P>
      Začít můžete <strong className="text-zinc-200">zdarma</strong> — plán FREE nabízí 3 AI analýzy denně a risk
      kalkulačku. PREMIUM (499 Kč/měsíc) přidává 30 analýz denně, deník se statistikami a AI mentora. ELITE
      (1 290 Kč/měsíc) je pro profesionály: 100 analýz denně, Prop Firm Guardian, Market Scanner, chytré alerty
      a prioritní AI.
    </P>
    <P>
      Registrace zabere minutu a nevyžaduje platební kartu. Budeme rádi za každou zpětnou vazbu — píšeme další
      funkce podle toho, co tradeři skutečně potřebují.
    </P>
  </>
);

const ChallengeArticle = () => (
  <>
    <P>
      Prop firm challenge je pro většinu traderů nejrychlejší cesta k velkému kapitálu — a zároveň místo, kde jich
      přes 90 % selže. Ne kvůli strategii, ale kvůli porušení pravidel: denní limit ztráty, maximální drawdown,
      přeobchodování. V tomto článku projdeme, jak challenge projít s pomocí AI, risk managementu a železné
      trading disciplíny.
    </P>
    <H2>Proč většina traderů v challenge selže</H2>
    <P>
      Prop trading firmy nastavují pravidla tak, aby přežili jen disciplinovaní tradeři: typicky 5% denní limit
      ztráty, 10% celkový drawdown a profit target 8–10 %. Zní to splnitelně — dokud nepřijde ztrátová série.
      Trader po dvou ztrátách zvýší pozici, aby se „dostal zpátky", a třetí ztráta mu vezme účet. Challenge
      nevyhrává ten, kdo umí nejlépe predikovat trh, ale ten, kdo nejlépe řídí riziko.
    </P>
    <H2>Pravidlo č. 1: riskujte méně, než si myslíte</H2>
    <P>
      Matematika challenge je nemilosrdná. Pokud riskujete 2 % na obchod, stačí tři ztráty za den a jste
      u denního limitu. Doporučené riziko pro challenge je <strong className="text-zinc-200">0,5–1 % na obchod</strong> —
      tak vám ani pět ztrát v řadě nevezme šanci pokračovat. Velikost pozice nikdy neodhadujte: spočítejte ji
      z velikosti účtu, rizika v procentech a vzdálenosti stop lossu.
    </P>
    <Img src="/blog/challenge-calculator.webp" alt="Risk kalkulačka pozic v TradeMind AI — výpočet velikosti pozice podle rizika a stop lossu" caption="Risk kalkulačka v TradeMind AI: velikost pozice na 1 kliknutí — účet, riziko v %, stop loss." />
    <P>
      V TradeMind AI je risk kalkulačka zdarma i ve FREE plánu. Zadáte velikost účtu, riziko na obchod a stop loss
      v pipech — a dostanete přesnou velikost pozice v lotech i maximální ztrátu v penězích. Žádné počítání
      z hlavy, žádné „ono to vyjde".
    </P>
    <H2>Obchodujte jen A-setupy — a naučte se čekat</H2>
    <P>
      Nejčastější zabiják challenge účtů je přeobchodování. Trader chce „urychlit" splnění profit targetu a bere
      i průměrné setupy. Opak je cesta: <strong className="text-zinc-200">méně obchodů, vyšší kvalita</strong>.
      AI analýza v TradeMind AI každý setup oznámkuje (A+ až F) a často řekne to, co trader slyšet nechce:
      POČKEJTE. Právě signál „počkejte" je pro challenge nejcennější — chrání kapitál na okamžik, kdy trh nabídne
      skutečnou příležitost.
    </P>
    <Img narrow src="/blog/challenge-dashboard.webp" alt="Mobilní dashboard TradeMind AI se sérií analýz a signály POČKEJTE a PRODAT" caption="Dashboard v mobilu: série analýz se signály POČKEJTE — disciplína znamená nechat průměrné setupy projít." />
    <H2>Deník: bez dat nevíte, co opravit</H2>
    <P>
      Obchodní deník je nejpodceňovanější nástroj v tradingu. Kdo si nezapisuje obchody, opakuje stejné chyby
      donekonečna. Zapisujte ke každému obchodu instrument, směr, RR, výsledek a hlavně důvod vstupu. Po dvaceti
      obchodech uvidíte vzorce: ve kterou denní dobu ztrácíte, který instrument vám nesedí, kdy porušujete plán.
      TradeMind AI deník doplní statistiky, winrate a equity křivku automaticky — a AI mentor vám z dat řekne,
      co konkrétně zlepšit.
    </P>
    <H2>Guardian: pojistka proti nejdražší chybě</H2>
    <P>
      Porušení denního limitu ztráty znamená konec challenge — a peníze za ni zpět nedostanete. Prop Firm
      Guardian v TradeMind AI sleduje váš účet a varuje, když se limitu blížíte. Je to poslední pojistka pro
      chvíle, kdy emoce přebijí plán. Nastavíte si parametry svého challenge (denní limit, max. drawdown, profit
      target) a aplikace hlídá za vás.
    </P>
    <H2>Checklist pro průchod challenge</H2>
    <P>
      1) Riskujte max. 0,5–1 % na obchod a velikost pozice vždy počítejte. 2) Obchodujte jen A-setupy — když si
      nejste jisti, počkejte. 3) Max. 2–3 obchody denně; po dvou ztrátách končíte. 4) Veďte deník a jednou týdně
      ho vyhodnoťte. 5) Hlídejte vzdálenost od denního limitu — ideálně automaticky. 6) Profit target nespěchá:
      challenge je maraton, ne sprint.
    </P>
    <P>
      Disciplína se nedá koupit — ale dá se systematizovat. Přesně k tomu je TradeMind AI: AI mentor, risk
      kalkulačka, deník a Guardian v jedné aplikaci, česky a od 0 Kč.
    </P>
  </>
);

export const ARTICLES = [
  {
    slug: "jak-projit-prop-firm-challenge-s-ai",
    title: "Jak projít prop firm challenge s AI: risk management, disciplína a A-setupy",
    date: "20. 6. 2026",
    dateISO: "2026-06-20",
    description:
      "Přes 90 % prop firm challenge účtů končí neúspěchem. Návod, jak projít challenge s pomocí AI: risk management, obchodní deník, A-setupy a ochrana denního limitu ztráty.",
    image: "/blog/challenge-calculator.webp",
    Content: ChallengeArticle,
  },
  {
    slug: "spusteni-trademind-ai",
    title: "TradeMind AI startuje: AI mentor, obchodní deník a ochrana prop firm účtu v jedné aplikaci",
    date: "1. 6. 2026",
    dateISO: "2026-06-01",
    description:
      "Představujeme TradeMind AI — českou aplikaci pro prop trading a retail tradery. AI analýza grafů, obchodní deník, risk management a Prop Firm Guardian v jedné platformě.",
    image: "/icons/icon-512.png",
    Content: LaunchArticle,
  },
];

export const ArticleCTA = ({ lang }) => (
  <div className="mt-10 p-6 rounded-xl border border-amber-500/30 bg-amber-500/5">
    <div className="text-lg font-semibold text-zinc-100 mb-2">
      {lang === "cs" ? "Vyzkoušejte TradeMind AI zdarma" : "Try TradeMind AI for free"}
    </div>
    <p className="text-sm text-zinc-400 mb-4">
      {lang === "cs"
        ? "3 AI analýzy denně, risk kalkulačka a obchodní deník. Bez platební karty."
        : "3 AI analyses a day, risk calculator and trading journal. No credit card."}
    </p>
    <Link to="/register" data-testid="blog-cta-register" className="inline-block px-5 py-2.5 rounded-md text-sm font-medium bg-amber-500 hover:bg-amber-400 text-zinc-950 transition-colors">
      {lang === "cs" ? "Začít zdarma" : "Start free"}
    </Link>
  </div>
);
